import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ReportData } from 'src/shared/models/report-data.model';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';
import { Constants } from 'src/shared/utilities/constants.util';
import { ReportService } from 'src/shared/services/report.service';
import { ReportConstants } from '../../shared/report-constants.util';

@Component({
    selector: 'total-uos-reasons-for-variance-drilldown-page',
    templateUrl: './total-uos-reasons-for-variance-drilldown-page.component.html',
    styleUrls: ['./total-uos-reasons-for-variance-drilldown-page.component.scss']
})
export class TotalUosReasonsForVarianceDrillDownPageComponent implements OnInit {
    reasonsForVarianceData :ReportData;
    filterEventsSubject: Subject<void> = new Subject<void>();
    filters:ReportFilters;
    views:string[];

    constructor(private reportService: ReportService)
    {
        this.filters = new ReportFilters();
        this.views = [ 
            ReportConstants.DateViewLabel,
            ReportConstants.DayOfWeekViewLabel,
            ReportConstants.ShiftBlockViewLabel, 
            ReportConstants.PeriodEndViewLabel, 
            ReportConstants.WeekViewLabel
        ];
        this.filters.ReportView = ReportConstants.DateViewLabel;
    }

    ngOnInit() {
        this.reasonsForVarianceData = new ReportData();
        this.reportService.announceSummarySelected(Constants.TotalUosSummary);
    }
    reasonsForVarianceDataUpdated(reportData: ReportData)
    {
        this.reasonsForVarianceData = reportData;
    }

    filterUpdated(filters:ReportFilters)
    {
        this.filters = filters;
        this.filterEventsSubject.next();
    }

    getShiftBlockDescription(startHour: number, endHour: number): string {
        return MiscUtil.getShiftBlockDescription(startHour, endHour);
    }
}
